require.register("thesaurus/controllers/editCtrl", function(exports, require, module){
  $0
  
});

